import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { getUser } from "../../../../api";
import Button from "@material-ui/core/Button";
import ListRoundedIcon from "@material-ui/icons/ListRounded";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useDispatch, useSelector } from "react-redux";
import UserInfoComponent from "./components/UserInfoComponent";
import DFALoginComponent from "./components/DFALoginComponent";
import UserCredentialsComponent from "./components/UserCredentialsComponent";
import UserPersonalDataComponent from "./components/UserPersonalDataComponent";
import { ACCORDION_SECTIONS, ROUTES_USERS, USER_STATUS_ACTIVE, USER_STATUS_BLOCKED } from "../../../../utils/constants";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { setUserTypeAction } from "../../../../reducers";

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    padding: theme.spacing(4, 2),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
  },
  title: {
    textTransform: "upperCase",
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
  },
  sectionBlock: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  showLayout: {
    height: "100%",
    display: "flex",
    gap: theme.spacing(3),
    padding: theme.spacing(4),
  },
  keyValue: {
    display: "flex",
    flexDirection: "column",
  },
  button: theme.classes.mainButton,
  secondaryButton: theme.classes.secondaryButton,
  iconButton: theme.classes.secondaryButton,
  warningButton: theme.classes.warningButton,
  accordion: {
    width: "100%",
    margin: theme.spacing(0, 2),
    "&.MuiAccordion-root.Mui-expanded": {
      margin: theme.spacing(0, 2),
    },
  },
  accordionHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    justifyContent: "space-between",
    width: "100%",
  },
  accordionTitle: {
    flex: 1,
  },
  //
  paper: {
    padding: theme.spacing(4),
  },
  statusCell: {
    color: "red",
    display: "flex",
    gap: theme.spacing(1),
  },
  tooltip: {
    marginTop: theme.spacing(4),
  },
  mailEllipsis: {
    maxWidth: 460,
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
}));

export const UserEdit = () => {
  const classes = useStyles();
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const storageIdCrm = localStorage.getItem("masbranIdCrm");
  const idCrm = useSelector((state) => state.idCrm);
  const userType = useSelector((state) => state.userType) || {};
  const type = +userType.id === +id ? userType?.type : " - ";
  const loading = useSelector((state) => state.loading);

  const [user, setUser] = useState(null);
  const [expanded, setExpanded] = useState(ACCORDION_SECTIONS);

  const unavailableStatus =
    user?.estadoUsuario?.descripcion !== USER_STATUS_BLOCKED && user?.estadoUsuario?.descripcion !== USER_STATUS_ACTIVE;

  const handleSetExpanded = (panel) => {
    let sections = [...expanded];

    if (!!sections.includes(panel)) {
      sections = sections.filter((section) => section !== panel);
    } else {
      sections.push(panel);
    }

    setExpanded(sections);
  };

  const handleSetUser = (data) => {
    setUser(data);
  };

  const handleGetUser = () => {
    getUser(idCrm || storageIdCrm, id, handleSetUser);
  };

  useEffect(() => {
    (idCrm || storageIdCrm) && !user && handleGetUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idCrm]);

  const handleGoBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (!idCrm && !storageIdCrm) {
      navigate(ROUTES_USERS);
    }
    return () => dispatch(setUserTypeAction(null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.pageContainer}>
      <Typography variant={"h4"} className={classes.title}>
        {intl.formatMessage({ id: "custom.user.user_settings" })}
      </Typography>
      <Grid container spacing={2}>
        <Grid item md={12} lg={2}>
          <Button startIcon={<ListRoundedIcon />} className={classes.button} onClick={handleGoBack}>
            {intl.formatMessage({ id: "ra.action.back_list" })}
          </Button>
        </Grid>
        <Grid item xs={2}>
          {loading && <CircularProgress color="primary" />}
        </Grid>
      </Grid>
      <Grid item container spacing={2} xs={12}>
        <Grid item xs={12}>
          <UserInfoComponent
            classes={classes}
            id={id}
            user={user}
            idCrm={idCrm}
            type={type}
            handleGetUser={handleGetUser}
            expanded={expanded}
            handleSetExpanded={handleSetExpanded}
            unavailableStatus={unavailableStatus}
          />
        </Grid>
        <Grid item xs={12}>
          <DFALoginComponent
            classes={classes}
            id={id}
            user={user}
            idCrm={idCrm}
            handleGetUser={handleGetUser}
            expanded={expanded}
            handleSetExpanded={handleSetExpanded}
          />
        </Grid>
        <Grid item xs={12}>
          <UserCredentialsComponent
            classes={classes}
            id={id}
            user={user}
            idCrm={idCrm}
            handleGetUser={handleGetUser}
            expanded={expanded}
            handleSetExpanded={handleSetExpanded}
          />
        </Grid>
        <Grid item xs={12}>
          <UserPersonalDataComponent
            classes={classes}
            id={id}
            user={user}
            idCrm={idCrm}
            handleGetUser={handleGetUser}
            expanded={expanded}
            handleSetExpanded={handleSetExpanded}
          />
        </Grid>
      </Grid>
    </div>
  );
};
